import React from "react";
import Header from "../components/Header";
 

function OrdersScreen() {
  return(
    <>
       <Header />
       
    </>
  )
}

export default OrdersScreen;
